var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0058 24.9836C28.9029 24.9836 24.7063 29.1449 24.7063 34.2047C24.7063 37.7993 26.7638 40.0013 26.7638 40.0013C30.4705 44.4864 37.4676 44.4864 41.1662 40.0013C42.4807 38.366 43.2237 36.3258 43.2237 34.2047C43.3054 29.1449 39.1087 24.9836 34.0058 24.9836ZM34.0058 26.0442C38.529 26.0442 42.2358 29.7197 42.2358 34.2047C42.2358 35.9211 41.7459 37.5483 40.758 38.8598C39.5251 37.5564 37.9575 36.6578 36.2348 36.2449C37.1411 35.5891 37.7126 34.5286 37.7126 33.3061C37.7126 31.266 36.0633 29.6306 34.0058 29.6306C31.9483 29.6306 30.2991 31.266 30.2991 33.3061C30.2991 34.5286 30.8788 35.5891 31.7769 36.2449C30.046 36.6497 28.4865 37.5483 27.2455 38.8598C26.2576 37.4754 25.7677 35.8401 25.7677 34.2047C25.7677 29.7116 29.4745 26.0442 33.9977 26.0442H34.0058ZM31.287 33.3061C31.287 31.8408 32.5198 30.6102 34.0058 30.6102C35.4918 30.6102 36.7247 31.8327 36.7247 33.3061C36.7247 34.7796 35.4918 36.002 34.0058 36.002C32.5198 36.002 31.287 34.7796 31.287 33.3061ZM27.915 39.6775C31.2054 36.083 36.8879 36.083 40.1783 39.6775C36.8063 43.272 31.1237 43.272 27.915 39.6775Z",
    fill: "url(#paint0_linear_406_914)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0058 20.4095C26.3474 20.4095 20.0933 26.6108 20.0933 34.2047C20.0933 37.7992 21.4894 41.2238 24.045 43.8387L20.7546 47.1013C20.5913 47.2633 20.5913 47.4252 20.673 47.6761C20.7546 47.838 20.9179 48 21.1628 48H34.0875C41.7459 48 48.0001 41.7986 48.0001 34.2047C48.0001 26.6108 41.6643 20.4095 34.0058 20.4095ZM34.0058 46.9394H22.3141L25.1145 44.1626C25.1962 44.0816 25.2778 43.9197 25.2778 43.8387C25.2778 43.6768 25.1962 43.5958 25.1145 43.5149C22.559 41.0699 21.1628 37.7993 21.1628 34.2938C21.1628 27.2747 26.9271 21.5591 34.0058 21.5591C41.0846 21.5591 46.8489 27.2747 46.8489 34.2938C46.8489 41.3128 41.0846 46.9475 34.0058 46.9475V46.9394Z",
    fill: "url(#paint1_linear_406_914)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8632 19.5919C15.8965 19.5919 18.0356 16.6531 18.0356 16.7341C19.1869 15.3497 19.8482 13.5525 19.8482 11.7552C19.8482 7.43203 16.3129 3.91846 11.9448 3.91846C7.57675 3.91846 4.04146 7.43203 4.04146 11.7552C3.95981 16.0783 7.41342 19.5919 11.8632 19.5919ZM6.84193 16.4103C9.56076 13.4715 14.2472 13.4715 16.9661 16.4103C14.2472 19.349 9.56076 19.349 6.84193 16.4103ZM9.6424 11.0266C9.6424 9.8041 10.6303 8.82451 11.8632 8.82451C13.096 8.82451 14.084 9.8041 14.084 11.0266C14.084 12.249 13.096 13.2286 11.8632 13.2286C10.6303 13.2286 9.6424 12.1681 9.6424 11.0266ZM11.8632 4.90615C15.6516 4.90615 18.7787 8.00681 18.7787 11.7633C18.7787 13.1476 18.3704 14.4592 17.6274 15.6007C16.6395 14.5401 15.4066 13.8034 14.0023 13.4796C14.7453 12.9048 15.1535 12.0142 15.1535 11.0346C15.1535 9.23738 13.6676 7.853 11.9448 7.853C10.2221 7.853 8.73614 9.31834 8.73614 11.0346C8.73614 12.0142 9.22599 12.9129 9.88733 13.4796C8.49117 13.8844 7.25014 14.5401 6.26222 15.6007C5.51924 14.4592 5.11103 13.1557 5.11103 11.7633C4.94773 8.00681 8.07476 4.90615 11.8632 4.90615Z",
    fill: "url(#paint2_linear_406_914)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8121 23.5102C23.3019 23.5102 23.4734 22.9354 23.1386 22.6116L20.4198 19.9157C22.559 17.7136 23.7101 14.8558 23.7101 11.7551C23.7101 5.31086 18.4439 0 11.855 0C5.26617 0 0 5.22181 0 11.7551C0 18.2884 5.26617 23.5102 11.855 23.5102H22.8039H22.8121ZM1.07774 11.7551C1.07774 5.87757 5.93568 1.06057 11.8632 1.06057C17.7908 1.06057 22.6488 5.87757 22.6488 11.7551C22.6488 14.6939 21.4975 17.4707 19.2767 19.5109C19.0318 19.6728 19.0318 19.9966 19.2767 20.2476L21.4976 22.4497H11.8632C5.93568 22.4497 1.07774 17.6327 1.07774 11.7551Z",
    fill: "url(#paint3_linear_406_914)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_914",
    x1: 33.9656,
    y1: 24.9836,
    x2: 33.9656,
    y2: 43.3651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_406_914",
    x1: 34.0467,
    y1: 20.4095,
    x2: 34.0467,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_406_914",
    x1: 11.9441,
    y1: 3.91846,
    x2: 11.9441,
    y2: 19.5919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_406_914",
    x1: 11.8551,
    y1: 0,
    x2: 11.8551,
    y2: 23.5102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.9c6fae32645ae134e6a0ad15e34282d4.svg";
export { ForwardRef as ReactComponent };